/**
 * Creates a function that returns an object with the type key, and takes any args and sets them as keys.
 * Used to reduce action creation boilerplate.
 * @param {String} type - Gets assigned to the 'type' key.
 * @param {Array<String>} argNames - Holds the other keys to be set to the object.
 * @return {Object}
 */

export default function actionCreator(type, ...argNames) {
  return function(...args) {
    let action = { type }
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index]
    })
    return action
  }
}



// WEBPACK FOOTER //
// ./src/helpers/actionCreator.js